export function Nav() {
  return (
    <nav className="fixed left-0 right-0 top-0 z-[200] flex h-11 items-center justify-between border-b border-[var(--hairline)] bg-[var(--background)]/95 px-6 backdrop-blur md:px-10">
      <a href="#top" className="flex items-center gap-2.5">
        <span className="font-display text-[18px] leading-none tracking-[0.32em] text-gradient-amber">
          OMNIFIC
        </span>
      </a>
      <div className="flex items-center gap-7 text-[10px] uppercase tracking-[0.18em]">
        <a href="#audit" className="hidden text-[var(--dim-2)] transition-colors hover:text-[var(--amber-bright)] md:inline">
          Audit
        </a>
        <a href="#engage" className="hidden text-[var(--dim-2)] transition-colors hover:text-[var(--amber-bright)] md:inline">
          Engage
        </a>
      </div>
    </nav>
  );
}
